import { Link } from 'react-router-dom'
import { ORDER_PATHS, ORDER_UI, type OrderCardProps } from '../constants/orders'
import { formatCurrency, formatDateTime } from '../helpers/format'
import {
  deliveryPromiseLabel,
  orderItemCountLabel,
  orderPreviewItems,
  orderStatusLabel,
  paymentStatusLabel,
} from '../helpers/orders'
import { useCanCancelOrder } from '../hooks/useCanCancelOrder'
import '../styles/orders-page.scss'

export function OrderCard({ order, cancelling, onCancel }: OrderCardProps) {
  const previews = orderPreviewItems(order)
  const canCancel = useCanCancelOrder(order)

  return (
    <article className="order-card">
      <div className="order-card__top">
        <div className="order-card__identity">
          {previews.length > 0 ? (
            <div className="order-card__thumbs" aria-hidden>
              {previews.map((item) => (
                <span key={item.id} className="order-card__thumb">
                  {item.url ? <img src={item.url} alt="" /> : <span />}
                </span>
              ))}
            </div>
          ) : null}
          <div>
            <Link to={ORDER_PATHS.detail(order.id)} className="order-card__number">
              {order.orderNumber}
            </Link>
            <p className="order-card__meta">
              {formatDateTime(order.createdAt)} · {orderItemCountLabel(order)}
            </p>
          </div>
        </div>
        <div className="order-card__badges">
          <span className={`order-status order-status--${order.status}`}>
            {orderStatusLabel(order.status)}
          </span>
          <span
            className={`order-sla${order.isExpress ? ' order-sla--express' : ''}`}
          >
              {deliveryPromiseLabel(order)}
          </span>
        </div>
      </div>
      <p className="order-card__items">
        {order.items.map((item) => `${item.productName} × ${item.quantity}`).join(' · ')}
      </p>
      <div className="order-card__footer">
        <div className="order-card__total">
          <strong>{formatCurrency(order.total)}</strong>
          <span className="order-card__meta">
            {ORDER_UI.paymentLabel}: {paymentStatusLabel(order.paymentStatus)}
          </span>
        </div>
        <div className="order-card__actions">
          <Link to={ORDER_PATHS.detail(order.id)}>{ORDER_UI.viewOrder}</Link>
          {onCancel && canCancel ? (
            <button
              type="button"
              onClick={() => {
                if (window.confirm(ORDER_UI.cancelConfirm)) {
                  onCancel(order.id)
                }
              }}
              disabled={cancelling}
            >
              {cancelling ? ORDER_UI.cancelling : ORDER_UI.cancel}
            </button>
          ) : null}
        </div>
      </div>
    </article>
  )
}
